import $ from 'jquery';

class Share {
    constructor() {
        this.initialize();
    }

    initialize() {
        this.$shareLinks = $('.js-share-link');
        this.addClickHandlers();
    }

    addClickHandlers() {
        this.$shareLinks.on('click', e => {
            e.preventDefault();
            this.handleEventTracking(
                e.currentTarget.dataset.category,
                e.currentTarget.dataset.label
            );
            this.showPopup(e.currentTarget.href);
        });
    }

    handleEventTracking(category, label) {
        console.log(`category: ${category}\nlabel: ${label}`);
        if (typeof gtag === 'function') {
            gtag('event', 'click', {
                event_category: category,
                event_label: label,
            });
        }   
        console.log('Data Layer:', window.dataLayer);
    }

    showPopup(url) {
        const width = 1000;
        const height = 600;
        const top = $(window).height() / 2 - height / 2;
        const left = $(window).width() / 2 - width / 2;
        const opts = `width=${width}, height=${height}, top=${top}, left=${left}, toolbar=0, location=0, menubar=0, directories=0, scrollbars=0`;
        window.open(url, 'shareWindow', opts);
    }

    static init() {
        if ($('.share').length > 0) {
            new Share();
        }
    }
}

export default Share;
